// extracted by mini-css-extract-plugin
export default {"trainingModule":"study-page_trainingModule__zOv6j","form":"study-page_form__PSOFq","trainingTag":"study-page_trainingTag__vlIys"};